export default {
    getDatatableES() {
        return {
            "decimal": "",
            "emptyTable": "No hay información",
            "info": "Mostrando _START_ a _END_ de _TOTAL_ Registros",
            "infoEmpty": "Mostrando 0 to 0 of 0 Registros",
            "infoFiltered": "(Filtrado de _MAX_ total Registros)",
            "infoPostFix": "",
            "thousands": ",",
            "lengthMenu": "Mostrar _MENU_ Registros",
            "loadingRecords": "Cargando...",
            "processing": "Procesando...",
            "search": "Buscar:",
            "zeroRecords": "Sin resultados encontrados",
            "paginate": {
                "first": "Primero",
                "last": "Ultimo",
                "next": "Siguiente",
                "previous": "Anterior"
            }
        }
    },
    //Inicio llenar combos
    async getArea(param = '') {
        let url = "api/area/llenar_combo";
        if (param.length > 5)
            url = url + "?" + getFilterURL(param)
        let data = await axios.get(url)
            .then(response => { return response.data; })
        if (!data)
            data = [];
        return data;
    },
    async getConfiguracion() {

        return [
            { "id": 1, "clave": "ant_hora_inicio_validacion", 'valor': '120', 'descripcion': '' },
            { "id": 2, "clave": "area_sol_acceso", 'valor': '1', 'descripcion': 'CGSV' },
            { "id": 3, "clave": "ant_hora_inicio_sol_acceso", 'valor': '360', 'descripcion': 'CGSV' },
            { "id": 4, "clave": "duracion_sol_acceso", 'valor': '30', 'descripcion': '' },
            { "id": 4, "clave": "duracion_con_ventana", 'valor': '30', 'descripcion': '' },


        ]
    },
    /* async getHerramienta() {
        let data = await axios.get("api/herramienta/llenar_combo")
            .then(response => { return response.data; })
        if (!data)
            data = [];
        return data;
    }, */

    getHerramienta() {
        return [
            { "id": 1, "nombre": "Actividades de Dataminer", 'class': 'info' },
            { "id": 2, "nombre": "Actividades sobre sondas Inspector", 'class': 'default' },
            { "id": 3, "nombre": "Actividades sobre Zabbix", 'class': 'success' },
        ]
    },
    getTipoArea() {
        return [
            { "id": 1, "codigo": '001', "nombre": "PAT" },
            { "id": 2, "codigo": '002', "nombre": "Ejecutor" },
        ]
    },
    getEstadoOrdenTrabajoTecnico() {
        return [
            { "id": 3, "nombre": "Pendiente de aprobación técnica", 'class': 'dark' },
            { "id": 11, "nombre": "Observado Técnicamente", 'class': 'warning' }
        ]
    },
    getEstadoOrdenTrabajo() {
        return [
            { "id": 1, "nombre": "Registro parcial", 'class': 'secondary' },
            { "id": 2, "nombre": "Registrado", 'class': 'success' },
            { "id": 3, "nombre": "Pendiente de aprobación técnica", 'class': 'dark' },
            { "id": 4, "nombre": "Aprobado técnicamente", 'class': 'info' },
            { "id": 5, "nombre": "Planificado", 'class': 'primary' },
            { "id": 6, "nombre": "Activado", 'class': 'info' },
            { "id": 7, "nombre": "Finalizado", 'class': 'dark' },
            { "id": 10, "nombre": "Observado por Gestor antes de PAT", 'class': 'warning' },
            { "id": 11, "nombre": "Observado por Gestor", 'class': 'warning' },
            // { "id": 11, "nombre": "Observado Técnicamente", 'class': 'warning' },
            // { "id": 12, "nombre": "Observado por Mesa", 'class': 'warning' },
            { "id": 20, "nombre": "Cancelado", 'class': 'danger' },

        ]
    },
    getTipoOrdenTrabajo() {
        return [
            { "id": 1, "codigo": '001', "nombre": "Tipo trabajo 01", 'class': 'info' },
            { "id": 2, "codigo": '002', "nombre": "Tipo trabajo 02", 'class': 'succes' },
            { "id": 3, "codigo": '003', "nombre": "Tipo  trabajo 03", 'class': 'primary' },
        ]
    },
    getTipoPlataforma() {
        return [
            { "id": 1, "codigo": '001', "nombre": "DTH", 'class': 'info' },
            { "id": 2, "codigo": '002', "nombre": "CATV", 'class': 'primary' },
            { "id": 3, "codigo": '003', "nombre": "OTT", 'class': 'secondary' },
            { "id": 4, "codigo": '004', "nombre": "IPTV", 'class': 'light' },
        ]
    },
    getTipoServicio() {
        return [
            { "id": 1, "codigo": '001', "nombre": "CS_DTH_CATV", 'class': 'info' },
            { "id": 2, "codigo": '002', "nombre": "CS_OTT_VOD", 'class': 'primary' },
            { "id": 3, "codigo": '002', "nombre": "CS_DTH_CATV - CS_OTT_VOD", 'class': 'dark' },
        ]
    },
    getOBS() {
        return [
            { 'id': 1, 'plataforma': 1, 'servicio': '1', 'codigo': 'BO_AXS', 'nombre': 'AXS', },
            { 'id': 3, 'plataforma': 1, 'servicio': '1', 'codigo': 'CL', 'nombre': 'CHILE', },
            { 'id': 4, 'plataforma': 1, 'servicio': '1', 'codigo': 'CO', 'nombre': 'COLOMBIA', },
            { 'id': 5, 'plataforma': 1, 'servicio': '1', 'codigo': 'EC_CNT', 'nombre': 'CNT', },
            { 'id': 6, 'plataforma': 1, 'servicio': '1', 'codigo': 'NI', 'nombre': 'NICARAGUA', },
            { 'id': 8, 'plataforma': 1, 'servicio': '1', 'codigo': 'VZ', 'nombre': 'VENEZUELA', },
            { 'id': 9, 'plataforma': 1, 'servicio': '1', 'codigo': 'BO_CMT', 'nombre': 'COMTECO', },
            { 'id': 11, 'plataforma': 1, 'servicio': '1', 'codigo': 'CL_CTV', 'nombre': 'CLARO TV', },
            { 'id': 14, 'plataforma': 1, 'servicio': '1', 'codigo': 'NINGUNO', 'nombre': 'NO AFECTACION SOBRE NINGUNA OPERADORA', },
            { 'id': 15, 'plataforma': 1, 'servicio': '1', 'codigo': 'PE', 'nombre': 'PERU', },
            { 'id': 16, 'plataforma': 1, 'servicio': '1', 'codigo': 'BR', 'nombre': 'BRASIL', },
            { 'id': 18, 'plataforma': 1, 'servicio': '1', 'codigo': 'CL_ENT', 'nombre': 'ENTEL', },
            { 'id': 19, 'plataforma': 1, 'servicio': '1', 'codigo': 'CR', 'nombre': 'COSTA RICA', },
            { 'id': 22, 'plataforma': 1, 'servicio': '1', 'codigo': 'SV', 'nombre': 'EL SALVADOR', },
            { 'id': 23, 'plataforma': 3, 'servicio': '2', 'codigo': 'UY', 'nombre': 'URUGUAY', },
            { 'id': 24, 'plataforma': 3, 'servicio': '2', 'codigo': 'ARG', 'nombre': 'ARGENTINA', },
            { 'id': 25, 'plataforma': 3, 'servicio': '2', 'codigo': 'MX', 'nombre': 'MEXICO', },
            { 'id': 26, 'plataforma': 3, 'servicio': '2', 'codigo': 'CL', 'nombre': 'CHILE', },
            { 'id': 27, 'plataforma': 3, 'servicio': '2', 'codigo': 'CO', 'nombre': 'COLOMBIA', },
            { 'id': 28, 'plataforma': 3, 'servicio': '2', 'codigo': 'ECU', 'nombre': 'ECUADOR', },
            { 'id': 29, 'plataforma': 3, 'servicio': '2', 'codigo': 'PE', 'nombre': 'PERU', },
            { 'id': 30, 'plataforma': 3, 'servicio': '2', 'codigo': 'PE LXD', 'nombre': 'PERU LXD', },
            { 'id': 31, 'plataforma': 2, 'servicio': '1', 'codigo': 'BO_AXS', 'nombre': 'AXS', },
            { 'id': 33, 'plataforma': 2, 'servicio': '1', 'codigo': 'CL', 'nombre': 'CHILE', },
            { 'id': 34, 'plataforma': 2, 'servicio': '1', 'codigo': 'CO', 'nombre': 'COLOMBIA', },
            { 'id': 35, 'plataforma': 2, 'servicio': '1', 'codigo': 'EC_CNT', 'nombre': 'CNT', },
            { 'id': 36, 'plataforma': 2, 'servicio': '1', 'codigo': 'NI', 'nombre': 'NICARAGUA', },
            { 'id': 38, 'plataforma': 2, 'servicio': '1', 'codigo': 'VZ', 'nombre': 'VENEZUELA', },
            { 'id': 39, 'plataforma': 2, 'servicio': '1', 'codigo': 'BO_CMT', 'nombre': 'COMTECO', },
            { 'id': 41, 'plataforma': 2, 'servicio': '1', 'codigo': 'CL_CTV', 'nombre': 'CLARO TV', },
            { 'id': 45, 'plataforma': 2, 'servicio': '1', 'codigo': 'PE', 'nombre': 'PERU', },
            { 'id': 46, 'plataforma': 2, 'servicio': '1', 'codigo': 'BR', 'nombre': 'BRASIL', },
            { 'id': 48, 'plataforma': 2, 'servicio': '1', 'codigo': 'CL_ENT', 'nombre': 'ENTEL', },
            { 'id': 49, 'plataforma': 2, 'servicio': '1', 'codigo': 'CR', 'nombre': 'COSTA RICA', },
            { 'id': 52, 'plataforma': 2, 'servicio': '1', 'codigo': 'SV', 'nombre': 'EL SALVADOR', },
            { 'id': 53, 'plataforma': 4, 'servicio': '2', 'codigo': 'UY', 'nombre': 'URUGUAY', },
            { 'id': 54, 'plataforma': 4, 'servicio': '2', 'codigo': 'ARG', 'nombre': 'ARGENTINA', },
            { 'id': 55, 'plataforma': 4, 'servicio': '2', 'codigo': 'MX', 'nombre': 'MEXICO', },
            { 'id': 56, 'plataforma': 4, 'servicio': '2', 'codigo': 'CL', 'nombre': 'CHILE', },
            { 'id': 57, 'plataforma': 4, 'servicio': '2', 'codigo': 'CO', 'nombre': 'COLOMBIA', },
            { 'id': 58, 'plataforma': 4, 'servicio': '2', 'codigo': 'ECU', 'nombre': 'ECUADOR', },
            { 'id': 59, 'plataforma': 4, 'servicio': '2', 'codigo': 'PE', 'nombre': 'PERU', },
            { 'id': 60, 'plataforma': 4, 'servicio': '2', 'codigo': 'PE LXD', 'nombre': 'PERU LXD', },


        ]
    },
    getTS() {
        return [
            { "id": "53", "codigo": '001', "nombre": "53" },
            { "id": "89", "codigo": '001', "nombre": "89" },
            { "id": "176", "codigo": '001', "nombre": "176" },
            { "id": "101", "codigo": '001', "nombre": "101" },
            { "id": "184", "codigo": '001', "nombre": "184" },
            { "id": "185", "codigo": '001', "nombre": "185" },
            { "id": "102", "codigo": '001', "nombre": "102" },
            { "id": "123", "codigo": '001', "nombre": "123" },
            { "id": "103", "codigo": '001', "nombre": "103" },
            { "id": "104", "codigo": '001', "nombre": "104" },
            { "id": "105", "codigo": '001', "nombre": "105" },
            { "id": "106", "codigo": '001', "nombre": "106" },
            { "id": "108", "codigo": '001', "nombre": "108" },
            { "id": "109", "codigo": '001', "nombre": "109" },
            { "id": "110", "codigo": '001', "nombre": "110" },
            { "id": "111", "codigo": '001', "nombre": "111" },
            { "id": "112", "codigo": '001', "nombre": "112" },
            { "id": "113", "codigo": '001', "nombre": "113" },
            { "id": "114", "codigo": '001', "nombre": "114" },
            { "id": "115", "codigo": '001', "nombre": "115" },
            { "id": "116", "codigo": '001', "nombre": "116" },
            { "id": "117", "codigo": '001', "nombre": "117" },
            { "id": "118", "codigo": '001', "nombre": "118" },
            { "id": "119", "codigo": '001', "nombre": "119" },
            { "id": "120", "codigo": '001', "nombre": "120" },
            { "id": "121", "codigo": '001', "nombre": "121" },
            { "id": "124", "codigo": '001', "nombre": "124" },
            { "id": "175", "codigo": '001', "nombre": "175" },
            { "id": "177", "codigo": '001', "nombre": "177" },
            { "id": "178", "codigo": '001', "nombre": "178" },
            { "id": "179", "codigo": '001', "nombre": "179" },
            { "id": "180", "codigo": '001', "nombre": "180" },
            { "id": "181", "codigo": '001', "nombre": "181" },
            { "id": "183", "codigo": '001', "nombre": "183" },
            { "id": "187", "codigo": '001', "nombre": "187" },
            { "id": "189", "codigo": '001', "nombre": "189" },
            { "id": "190", "codigo": '001', "nombre": "190" },
            { "id": "191", "codigo": '001', "nombre": "191" },
            { "id": "192", "codigo": '001', "nombre": "192" },
            { "id": "193", "codigo": '001', "nombre": "193" },
            { "id": "194", "codigo": '001', "nombre": "194" },
            { "id": "196", "codigo": '001', "nombre": "196" },
            { "id": "125", "codigo": '001', "nombre": "125" },
            { "id": "172", "codigo": '001', "nombre": "172" },
            { "id": "KU 65", "codigo": '001', "nombre": "KU 65" },
            { "id": "KU 64", "codigo": '001', "nombre": "KU 64" },
            { "id": "KU 63", "codigo": '001', "nombre": "KU 63" },
            { "id": "KU 52B", "codigo": '001', "nombre": "KU 52B" },
            { "id": "KU 50", "codigo": '001', "nombre": "KU 50" },
            { "id": "KU 124", "codigo": '001', "nombre": "KU 124" },
            { "id": "KU 46", "codigo": '001', "nombre": "KU 46" },
            { "id": "KU 118", "codigo": '001', "nombre": "KU 118" },
            { "id": "KU 125", "codigo": '001', "nombre": "KU 125" },
            { "id": "KU 123", "codigo": '001', "nombre": "KU 123" },
            { "id": "KU 122", "codigo": '001', "nombre": "KU 122" },
            { "id": "KU 121", "codigo": '001', "nombre": "KU 121" },
            { "id": "KU 120", "codigo": '001', "nombre": "KU 120" },
            { "id": "KU 119", "codigo": '001', "nombre": "KU 119" },
            { "id": "KU 117", "codigo": '001', "nombre": "KU 117" },
            { "id": "KU 116", "codigo": '001', "nombre": "KU 116" },
            { "id": "KU 113", "codigo": '001', "nombre": "KU 113" },
            { "id": "KU 112", "codigo": '001', "nombre": "KU 112" },
            { "id": "KU 110", "codigo": '001', "nombre": "KU 110" },
            { "id": "7SES", "codigo": '001', "nombre": "7SES" },
            { "id": "8SES", "codigo": '001', "nombre": "8SES" },
            { "id": "9SES", "codigo": '001', "nombre": "9SES" },
            { "id": "10SES", "codigo": '001', "nombre": "10SES" },
            { "id": "11SES", "codigo": '001', "nombre": "11SES" },
            { "id": "12SES", "codigo": '001', "nombre": "12SES" },
            { "id": "KU 66", "codigo": '001', "nombre": "KU 66" },
            { "id": "KU 56", "codigo": '001', "nombre": "KU 56" },
            { "id": "KU 34", "codigo": '001', "nombre": "KU 34" },
            { "id": "KU 52", "codigo": '001', "nombre": "KU 52" },
            { "id": "KU 41", "codigo": '001', "nombre": "KU 41" },
            { "id": "KU 55", "codigo": '001', "nombre": "KU 55" },
            { "id": "KU 54", "codigo": '001', "nombre": "KU 54" },
            { "id": "KU 53", "codigo": '001', "nombre": "KU 53" },
            { "id": "KU 42", "codigo": '001', "nombre": "KU 42" },
            { "id": "KU 51", "codigo": '001', "nombre": "KU 51" },
            { "id": "KU 44", "codigo": '001', "nombre": "KU 44" },
            { "id": "KU 43", "codigo": '001', "nombre": "KU 43" },
            { "id": "KU 40", "codigo": '001', "nombre": "KU 40" },
            { "id": "KU 39", "codigo": '001', "nombre": "KU 39" },
            { "id": "KU 33", "codigo": '001', "nombre": "KU 33" },
            { "id": "-", "codigo": '001', "nombre": "-" },

        ]
    },
    getChannel() {
        return [
            { 'id': '2', 'nombre': '2' },
            { 'id': '4', 'nombre': '4' },
            { 'id': '7', 'nombre': '7' },
            { 'id': '8', 'nombre': '8' },
            { 'id': '10', 'nombre': '10' },
            { 'id': '11', 'nombre': '11' },
            { 'id': '29', 'nombre': '29' },
            { 'id': '32', 'nombre': '32' },
            { 'id': '34', 'nombre': '34' },
            { 'id': '36', 'nombre': '36' },
            { 'id': '41', 'nombre': '41' },
            { 'id': '100', 'nombre': '100' },
            { 'id': '102', 'nombre': '102' },
            { 'id': '103', 'nombre': '103' },
            { 'id': '104', 'nombre': '104' },
            { 'id': '105', 'nombre': '105' },
            { 'id': '106', 'nombre': '106' },
            { 'id': '107', 'nombre': '107' },
            { 'id': '108', 'nombre': '108' },
            { 'id': '109', 'nombre': '109' },
            { 'id': '110', 'nombre': '110' },
            { 'id': '113', 'nombre': '113' },
            { 'id': '114', 'nombre': '114' },
            { 'id': '116', 'nombre': '116' },
            { 'id': '117', 'nombre': '117' },
            { 'id': '118', 'nombre': '118' },
            { 'id': '119', 'nombre': '119' },
            { 'id': '120', 'nombre': '120' },
            { 'id': '121', 'nombre': '121' },
            { 'id': '122', 'nombre': '122' },
            { 'id': '123', 'nombre': '123' },
            { 'id': '124', 'nombre': '124' },
            { 'id': '125', 'nombre': '125' },
            { 'id': '126', 'nombre': '126' },
            { 'id': '130', 'nombre': '130' },
            { 'id': '131', 'nombre': '131' },
            { 'id': '132', 'nombre': '132' },
            { 'id': '133', 'nombre': '133' },
            { 'id': '134', 'nombre': '134' },
            { 'id': '135', 'nombre': '135' },
            { 'id': '136', 'nombre': '136' },
            { 'id': '137', 'nombre': '137' },
            { 'id': '138', 'nombre': '138' },
            { 'id': '139', 'nombre': '139' },
            { 'id': '140', 'nombre': '140' },
            { 'id': '141', 'nombre': '141' },
            { 'id': '142', 'nombre': '142' },
            { 'id': '143', 'nombre': '143' },
            { 'id': '144', 'nombre': '144' },
            { 'id': '145', 'nombre': '145' },
            { 'id': '146', 'nombre': '146' },
            { 'id': '151', 'nombre': '151' },
            { 'id': '152', 'nombre': '152' },
            { 'id': '153', 'nombre': '153' },
            { 'id': '154', 'nombre': '154' },
            { 'id': '155', 'nombre': '155' },
            { 'id': '156', 'nombre': '156' },
            { 'id': '157', 'nombre': '157' },
            { 'id': '158', 'nombre': '158' },
            { 'id': '159', 'nombre': '159' },
            { 'id': '160', 'nombre': '160' },
            { 'id': '161', 'nombre': '161' },
            { 'id': '162', 'nombre': '162' },
            { 'id': '163', 'nombre': '163' },
            { 'id': '164', 'nombre': '164' },
            { 'id': '165', 'nombre': '165' },
            { 'id': '166', 'nombre': '166' },
            { 'id': '167', 'nombre': '167' },
            { 'id': '195', 'nombre': '195' },
            { 'id': '196', 'nombre': '196' },
            { 'id': '197', 'nombre': '197' },
            { 'id': '198', 'nombre': '198' },
            { 'id': '199', 'nombre': '199' },
            { 'id': '200', 'nombre': '200' },
            { 'id': '205', 'nombre': '205' },
            { 'id': '206', 'nombre': '206' },
            { 'id': '207', 'nombre': '207' },
            { 'id': '208', 'nombre': '208' },
            { 'id': '209', 'nombre': '209' },
            { 'id': '211', 'nombre': '211' },
            { 'id': '212', 'nombre': '212' },
            { 'id': '213', 'nombre': '213' },
            { 'id': '214', 'nombre': '214' },
            { 'id': '215', 'nombre': '215' },
            { 'id': '216', 'nombre': '216' },
            { 'id': '217', 'nombre': '217' },
            { 'id': '218', 'nombre': '218' },
            { 'id': '222', 'nombre': '222' },
            { 'id': '223', 'nombre': '223' },
            { 'id': '224', 'nombre': '224' },
            { 'id': '226', 'nombre': '226' },
            { 'id': '227', 'nombre': '227' },
            { 'id': '229', 'nombre': '229' },
            { 'id': '231', 'nombre': '231' },
            { 'id': '234', 'nombre': '234' },
            { 'id': '235', 'nombre': '235' },
            { 'id': '236', 'nombre': '236' },
            { 'id': '238', 'nombre': '238' },
            { 'id': '239', 'nombre': '239' },
            { 'id': '240', 'nombre': '240' },
            { 'id': '241', 'nombre': '241' },
            { 'id': '251', 'nombre': '251' },
            { 'id': '252', 'nombre': '252' },
            { 'id': '254', 'nombre': '254' },
            { 'id': '255', 'nombre': '255' },
            { 'id': '260', 'nombre': '260' },
            { 'id': '301', 'nombre': '301' },
            { 'id': '302', 'nombre': '302' },
            { 'id': '303', 'nombre': '303' },
            { 'id': '304', 'nombre': '304' },
            { 'id': '306', 'nombre': '306' },
            { 'id': '307', 'nombre': '307' },
            { 'id': '308', 'nombre': '308' },
            { 'id': '309', 'nombre': '309' },
            { 'id': '310', 'nombre': '310' },
            { 'id': '311', 'nombre': '311' },
            { 'id': '312', 'nombre': '312' },
            { 'id': '313', 'nombre': '313' },
            { 'id': '315', 'nombre': '315' },
            { 'id': '316', 'nombre': '316' },
            { 'id': '317', 'nombre': '317' },
            { 'id': '318', 'nombre': '318' },
            { 'id': '319', 'nombre': '319' },
            { 'id': '320', 'nombre': '320' },
            { 'id': '321', 'nombre': '321' },
            { 'id': '322', 'nombre': '322' },
            { 'id': '323', 'nombre': '323' },
            { 'id': '324', 'nombre': '324' },
            { 'id': '325', 'nombre': '325' },
            { 'id': '326', 'nombre': '326' },
            { 'id': '334', 'nombre': '334' },
            { 'id': '335', 'nombre': '335' },
            { 'id': '336', 'nombre': '336' },
            { 'id': '337', 'nombre': '337' },
            { 'id': '338', 'nombre': '338' },
            { 'id': '339', 'nombre': '339' },
            { 'id': '340', 'nombre': '340' },
            { 'id': '341', 'nombre': '341' },
            { 'id': '342', 'nombre': '342' },
            { 'id': '343', 'nombre': '343' },
            { 'id': '344', 'nombre': '344' },
            { 'id': '345', 'nombre': '345' },
            { 'id': '346', 'nombre': '346' },
            { 'id': '347', 'nombre': '347' },
            { 'id': '348', 'nombre': '348' },
            { 'id': '349', 'nombre': '349' },
            { 'id': '350', 'nombre': '350' },
            { 'id': '351', 'nombre': '351' },
            { 'id': '352', 'nombre': '352' },
            { 'id': '353', 'nombre': '353' },
            { 'id': '354', 'nombre': '354' },
            { 'id': '355', 'nombre': '355' },
            { 'id': '356', 'nombre': '356' },
            { 'id': '357', 'nombre': '357' },
            { 'id': '358', 'nombre': '358' },
            { 'id': '359', 'nombre': '359' },
            { 'id': '360', 'nombre': '360' },
            { 'id': '361', 'nombre': '361' },
            { 'id': '362', 'nombre': '362' },
            { 'id': '363', 'nombre': '363' },
            { 'id': '364', 'nombre': '364' },
            { 'id': '365', 'nombre': '365' },
            { 'id': '366', 'nombre': '366' },
            { 'id': '368', 'nombre': '368' },
            { 'id': '369', 'nombre': '369' },
            { 'id': '370', 'nombre': '370' },
            { 'id': '371', 'nombre': '371' },
            { 'id': '372', 'nombre': '372' },
            { 'id': '374', 'nombre': '374' },
            { 'id': '375', 'nombre': '375' },
            { 'id': '376', 'nombre': '376' },
            { 'id': '377', 'nombre': '377' },
            { 'id': '378', 'nombre': '378' },
            { 'id': '379', 'nombre': '379' },
            { 'id': '381', 'nombre': '381' },
            { 'id': '383', 'nombre': '383' },
            { 'id': '387', 'nombre': '387' },
            { 'id': '389', 'nombre': '389' },
            { 'id': '390', 'nombre': '390' },
            { 'id': '392', 'nombre': '392' },
            { 'id': '393', 'nombre': '393' },
            { 'id': '394', 'nombre': '394' },
            { 'id': '401', 'nombre': '401' },
            { 'id': '402', 'nombre': '402' },
            { 'id': '403', 'nombre': '403' },
            { 'id': '404', 'nombre': '404' },
            { 'id': '405', 'nombre': '405' },
            { 'id': '406', 'nombre': '406' },
            { 'id': '407', 'nombre': '407' },
            { 'id': '408', 'nombre': '408' },
            { 'id': '409', 'nombre': '409' },
            { 'id': '410', 'nombre': '410' },
            { 'id': '411', 'nombre': '411' },
            { 'id': '415', 'nombre': '415' },
            { 'id': '416', 'nombre': '416' },
            { 'id': '423', 'nombre': '423' },
            { 'id': '424', 'nombre': '424' },
            { 'id': '425', 'nombre': '425' },
            { 'id': '426', 'nombre': '426' },
            { 'id': '431', 'nombre': '431' },
            { 'id': '432', 'nombre': '432' },
            { 'id': '434', 'nombre': '434' },
            { 'id': '435', 'nombre': '435' },
            { 'id': '436', 'nombre': '436' },
            { 'id': '437', 'nombre': '437' },
            { 'id': '438', 'nombre': '438' },
            { 'id': '439', 'nombre': '439' },
            { 'id': '440', 'nombre': '440' },
            { 'id': '441', 'nombre': '441' },
            { 'id': '442', 'nombre': '442' },
            { 'id': '443', 'nombre': '443' },
            { 'id': '444', 'nombre': '444' },
            { 'id': '447', 'nombre': '447' },
            { 'id': '448', 'nombre': '448' },
            { 'id': '449', 'nombre': '449' },
            { 'id': '450', 'nombre': '450' },
            { 'id': '458', 'nombre': '458' },
            { 'id': '460', 'nombre': '460' },
            { 'id': '461', 'nombre': '461' },
            { 'id': '462', 'nombre': '462' },
            { 'id': '463', 'nombre': '463' },
            { 'id': '464', 'nombre': '464' },
            { 'id': '465', 'nombre': '465' },
            { 'id': '467', 'nombre': '467' },
            { 'id': '468', 'nombre': '468' },
            { 'id': '476', 'nombre': '476' },
            { 'id': '477', 'nombre': '477' },
            { 'id': '478', 'nombre': '478' },
            { 'id': '479', 'nombre': '479' },
            { 'id': '480', 'nombre': '480' },
            { 'id': '481', 'nombre': '481' },
            { 'id': '482', 'nombre': '482' },
            { 'id': '483', 'nombre': '483' },
            { 'id': '484', 'nombre': '484' },
            { 'id': '485', 'nombre': '485' },
            { 'id': '486', 'nombre': '486' },
            { 'id': '487', 'nombre': '487' },
            { 'id': '488', 'nombre': '488' },
            { 'id': '489', 'nombre': '489' },
            { 'id': '490', 'nombre': '490' },
            { 'id': '491', 'nombre': '491' },
            { 'id': '492', 'nombre': '492' },
            { 'id': '493', 'nombre': '493' },
            { 'id': '494', 'nombre': '494' },
            { 'id': '495', 'nombre': '495' },
            { 'id': '496', 'nombre': '496' },
            { 'id': '497', 'nombre': '497' },
            { 'id': '498', 'nombre': '498' },
            { 'id': '501', 'nombre': '501' },
            { 'id': '502', 'nombre': '502' },
            { 'id': '503', 'nombre': '503' },
            { 'id': '504', 'nombre': '504' },
            { 'id': '506', 'nombre': '506' },
            { 'id': '507', 'nombre': '507' },
            { 'id': '508', 'nombre': '508' },
            { 'id': '510', 'nombre': '510' },
            { 'id': '511', 'nombre': '511' },
            { 'id': '514', 'nombre': '514' },
            { 'id': '521', 'nombre': '521' },
            { 'id': '539', 'nombre': '539' },
            { 'id': '540', 'nombre': '540' },
            { 'id': '541', 'nombre': '541' },
            { 'id': '542', 'nombre': '542' },
            { 'id': '543', 'nombre': '543' },
            { 'id': '544', 'nombre': '544' },
            { 'id': '545', 'nombre': '545' },
            { 'id': '546', 'nombre': '546' },
            { 'id': '547', 'nombre': '547' },
            { 'id': '548', 'nombre': '548' },
            { 'id': '550', 'nombre': '550' },
            { 'id': '551', 'nombre': '551' },
            { 'id': '552', 'nombre': '552' },
            { 'id': '553', 'nombre': '553' },
            { 'id': '554', 'nombre': '554' },
            { 'id': '555', 'nombre': '555' },
            { 'id': '556', 'nombre': '556' },
            { 'id': '566', 'nombre': '566' },
            { 'id': '567', 'nombre': '567' },
            { 'id': '595', 'nombre': '595' },
            { 'id': '596', 'nombre': '596' },
            { 'id': '597', 'nombre': '597' },
            { 'id': '600', 'nombre': '600' },
            { 'id': '601', 'nombre': '601' },
            { 'id': '602', 'nombre': '602' },
            { 'id': '603', 'nombre': '603' },
            { 'id': '604', 'nombre': '604' },
            { 'id': '605', 'nombre': '605' },
            { 'id': '606', 'nombre': '606' },
            { 'id': '607', 'nombre': '607' },
            { 'id': '608', 'nombre': '608' },
            { 'id': '609', 'nombre': '609' },
            { 'id': '611', 'nombre': '611' },
            { 'id': '612', 'nombre': '612' },
            { 'id': '615', 'nombre': '615' },
            { 'id': '616', 'nombre': '616' },
            { 'id': '617', 'nombre': '617' },
            { 'id': '629', 'nombre': '629' },
            { 'id': '630', 'nombre': '630' },
            { 'id': '631', 'nombre': '631' },
            { 'id': '632', 'nombre': '632' },
            { 'id': '633', 'nombre': '633' },
            { 'id': '634', 'nombre': '634' },
            { 'id': '635', 'nombre': '635' },
            { 'id': '638', 'nombre': '638' },
            { 'id': '647', 'nombre': '647' },
            { 'id': '648', 'nombre': '648' },
            { 'id': '649', 'nombre': '649' },
            { 'id': '650', 'nombre': '650' },
            { 'id': '651', 'nombre': '651' },
            { 'id': '652', 'nombre': '652' },
            { 'id': '653', 'nombre': '653' },
            { 'id': '654', 'nombre': '654' },
            { 'id': '655', 'nombre': '655' },
            { 'id': '656', 'nombre': '656' },
            { 'id': '657', 'nombre': '657' },
            { 'id': '659', 'nombre': '659' },
            { 'id': '660', 'nombre': '660' },
            { 'id': '661', 'nombre': '661' },
            { 'id': '662', 'nombre': '662' },
            { 'id': '663', 'nombre': '663' },
            { 'id': '665', 'nombre': '665' },
            { 'id': '666', 'nombre': '666' },
            { 'id': '667', 'nombre': '667' },
            { 'id': '668', 'nombre': '668' },
            { 'id': '669', 'nombre': '669' },
            { 'id': '672', 'nombre': '672' },
            { 'id': '674', 'nombre': '674' },
            { 'id': '675', 'nombre': '675' },
            { 'id': '676', 'nombre': '676' },
            { 'id': '677', 'nombre': '677' },
            { 'id': '678', 'nombre': '678' },
            { 'id': '679', 'nombre': '679' },
            { 'id': '680', 'nombre': '680' },
            { 'id': '681', 'nombre': '681' },
            { 'id': '682', 'nombre': '682' },
            { 'id': '683', 'nombre': '683' },
            { 'id': '703', 'nombre': '703' },
            { 'id': '716', 'nombre': '716' },
            { 'id': '732', 'nombre': '732' },
            { 'id': '734', 'nombre': '734' },
            { 'id': '742', 'nombre': '742' },
            { 'id': '769', 'nombre': '769' },
            { 'id': '770', 'nombre': '770' },
            { 'id': '772', 'nombre': '772' },
            { 'id': '773', 'nombre': '773' },
            { 'id': '774', 'nombre': '774' },
            { 'id': '775', 'nombre': '775' },
            { 'id': '776', 'nombre': '776' },
            { 'id': '777', 'nombre': '777' },
            { 'id': '778', 'nombre': '778' },
            { 'id': '779', 'nombre': '779' },
            { 'id': '781', 'nombre': '781' },
            { 'id': '782', 'nombre': '782' },
            { 'id': '783', 'nombre': '783' },
            { 'id': '784', 'nombre': '784' },
            { 'id': '785', 'nombre': '785' },
            { 'id': '788', 'nombre': '788' },
            { 'id': '789', 'nombre': '789' },
            { 'id': '790', 'nombre': '790' },
            { 'id': '801', 'nombre': '801' },
            { 'id': '802', 'nombre': '802' },
            { 'id': '803', 'nombre': '803' },
            { 'id': '804', 'nombre': '804' },
            { 'id': '805', 'nombre': '805' },
            { 'id': '806', 'nombre': '806' },
            { 'id': '807', 'nombre': '807' },
            { 'id': '809', 'nombre': '809' },
            { 'id': '811', 'nombre': '811' },
            { 'id': '813', 'nombre': '813' },
            { 'id': '814', 'nombre': '814' },
            { 'id': '817', 'nombre': '817' },
            { 'id': '818', 'nombre': '818' },
            { 'id': '819', 'nombre': '819' },
            { 'id': '820', 'nombre': '820' },
            { 'id': '822', 'nombre': '822' },
            { 'id': '823', 'nombre': '823' },
            { 'id': '824', 'nombre': '824' },
            { 'id': '825', 'nombre': '825' },
            { 'id': '826', 'nombre': '826' },
            { 'id': '827', 'nombre': '827' },
            { 'id': '828', 'nombre': '828' },
            { 'id': '829', 'nombre': '829' },
            { 'id': '830', 'nombre': '830' },
            { 'id': '831', 'nombre': '831' },
            { 'id': '832', 'nombre': '832' },
            { 'id': '833', 'nombre': '833' },
            { 'id': '834', 'nombre': '834' },
            { 'id': '835', 'nombre': '835' },
            { 'id': '836', 'nombre': '836' },
            { 'id': '837', 'nombre': '837' },
            { 'id': '838', 'nombre': '838' },
            { 'id': '839', 'nombre': '839' },
            { 'id': '840', 'nombre': '840' },
            { 'id': '841', 'nombre': '841' },
            { 'id': '842', 'nombre': '842' },
            { 'id': '843', 'nombre': '843' },
            { 'id': '844', 'nombre': '844' },
            { 'id': '845', 'nombre': '845' },
            { 'id': '846', 'nombre': '846' },
            { 'id': '847', 'nombre': '847' },
            { 'id': '848', 'nombre': '848' },
            { 'id': '849', 'nombre': '849' },
            { 'id': '850', 'nombre': '850' },
            { 'id': '851', 'nombre': '851' },
            { 'id': '852', 'nombre': '852' },
            { 'id': '853', 'nombre': '853' },
            { 'id': '854', 'nombre': '854' },
            { 'id': '855', 'nombre': '855' },
            { 'id': '856', 'nombre': '856' },
            { 'id': '857', 'nombre': '857' },
            { 'id': '858', 'nombre': '858' },
            { 'id': '859', 'nombre': '859' },
            { 'id': '860', 'nombre': '860' },
            { 'id': '861', 'nombre': '861' },
            { 'id': '862', 'nombre': '862' },
            { 'id': '863', 'nombre': '863' },
            { 'id': '864', 'nombre': '864' },
            { 'id': '865', 'nombre': '865' },
            { 'id': '866', 'nombre': '866' },
            { 'id': '867', 'nombre': '867' },
            { 'id': '868', 'nombre': '868' },
            { 'id': '869', 'nombre': '869' },
            { 'id': '870', 'nombre': '870' },
            { 'id': '871', 'nombre': '871' },
            { 'id': '872', 'nombre': '872' },
            { 'id': '873', 'nombre': '873' },
            { 'id': '874', 'nombre': '874' },
            { 'id': '875', 'nombre': '875' },
            { 'id': '876', 'nombre': '876' },
            { 'id': '878', 'nombre': '878' },
            { 'id': '879', 'nombre': '879' },
            { 'id': '880', 'nombre': '880' },
            { 'id': '881', 'nombre': '881' },
            { 'id': '882', 'nombre': '882' },
            { 'id': '883', 'nombre': '883' },
            { 'id': '884', 'nombre': '884' },
            { 'id': '885', 'nombre': '885' },
            { 'id': '886', 'nombre': '886' },
            { 'id': '887', 'nombre': '887' },
            { 'id': '888', 'nombre': '888' },
            { 'id': '891', 'nombre': '891' },
            { 'id': '892', 'nombre': '892' },
            { 'id': '893', 'nombre': '893' },
            { 'id': '894', 'nombre': '894' },
            { 'id': '895', 'nombre': '895' },
            { 'id': '897', 'nombre': '897' },
            { 'id': '900', 'nombre': '900' },
            { 'id': '902', 'nombre': '902' },
            { 'id': '903', 'nombre': '903' },
            { 'id': '911', 'nombre': '911' },
            { 'id': '912', 'nombre': '912' },
            { 'id': '913', 'nombre': '913' },
            { 'id': '914', 'nombre': '914' },
            { 'id': '915', 'nombre': '915' },
            { 'id': '916', 'nombre': '916' },
            { 'id': '917', 'nombre': '917' },
            { 'id': '918', 'nombre': '918' },
            { 'id': '919', 'nombre': '919' },
            { 'id': '920', 'nombre': '920' },
            { 'id': '921', 'nombre': '921' },
            { 'id': '922', 'nombre': '922' },
            { 'id': '923', 'nombre': '923' },
            { 'id': '924', 'nombre': '924' },
            { 'id': '950', 'nombre': '950' },
            { 'id': '951', 'nombre': '951' },
            { 'id': '952', 'nombre': '952' },
            { 'id': '953', 'nombre': '953' },
            { 'id': '954', 'nombre': '954' },
            { 'id': '955', 'nombre': '955' },
            { 'id': '956', 'nombre': '956' },
            { 'id': '957', 'nombre': '957' },
            { 'id': '958', 'nombre': '958' },
            { 'id': '959', 'nombre': '959' },
            { 'id': '960', 'nombre': '960' },
            { 'id': '967', 'nombre': '967' },
            { 'id': '968', 'nombre': '968' },
            { 'id': '969', 'nombre': '969' },
            { 'id': '970', 'nombre': '970' },
            { 'id': '971', 'nombre': '971' },
            { 'id': '1002', 'nombre': '1002' },
            { 'id': '1004', 'nombre': '1004' },
            { 'id': '1005', 'nombre': '1005' },
            { 'id': '1007', 'nombre': '1007' },
            { 'id': '1009', 'nombre': '1009' },
            { 'id': '1010', 'nombre': '1010' },
            { 'id': '1011', 'nombre': '1011' },
            { 'id': '1012', 'nombre': '1012' },
            { 'id': '1013', 'nombre': '1013' },
            { 'id': '1024', 'nombre': '1024' },
            { 'id': '1027', 'nombre': '1027' },
            { 'id': '1033', 'nombre': '1033' },
            { 'id': '1044', 'nombre': '1044' },
            { 'id': '1058', 'nombre': '1058' },
            { 'id': '1060', 'nombre': '1060' },
            { 'id': '1103', 'nombre': '1103' },
            { 'id': '1104', 'nombre': '1104' },
            { 'id': '1107', 'nombre': '1107' },
            { 'id': '1108', 'nombre': '1108' },
            { 'id': '1113', 'nombre': '1113' },
            { 'id': '1130', 'nombre': '1130' },
            { 'id': '1142', 'nombre': '1142' },
            { 'id': '1148', 'nombre': '1148' },
            { 'id': '1150', 'nombre': '1150' },
            { 'id': '1151', 'nombre': '1151' },
            { 'id': '1202', 'nombre': '1202' },
            { 'id': '1204', 'nombre': '1204' },
            { 'id': '1243', 'nombre': '1243' },
            { 'id': '1304', 'nombre': '1304' },
            { 'id': '1324', 'nombre': '1324' },
            { 'id': '1360', 'nombre': '1360' },
            { 'id': '1469', 'nombre': '1469' },
            { 'id': '1510', 'nombre': '1510' },
            { 'id': '1513', 'nombre': '1513' },
            { 'id': '1514', 'nombre': '1514' },
            { 'id': '1515', 'nombre': '1515' },
            { 'id': '1516', 'nombre': '1516' },
            { 'id': '1517', 'nombre': '1517' },
            { 'id': '1518', 'nombre': '1518' },
            { 'id': '1519', 'nombre': '1519' },
            { 'id': '1520', 'nombre': '1520' },
            { 'id': '1521', 'nombre': '1521' },
            { 'id': '1522', 'nombre': '1522' },
            { 'id': '1523', 'nombre': '1523' },
            { 'id': '1524', 'nombre': '1524' },
            { 'id': '1544', 'nombre': '1544' },
            { 'id': '1612', 'nombre': '1612' },
            { 'id': '1733', 'nombre': '1733' },
            { 'id': '1734', 'nombre': '1734' },
            { 'id': '1736', 'nombre': '1736' },
            { 'id': '1737', 'nombre': '1737' },
            { 'id': '1743', 'nombre': '1743' },
            { 'id': '1771', 'nombre': '1771' },
            { 'id': '1772', 'nombre': '1772' },
            { 'id': '1774', 'nombre': '1774' },
            { 'id': '1801', 'nombre': '1801' },
            { 'id': '1802', 'nombre': '1802' },
            { 'id': '1803', 'nombre': '1803' },
            { 'id': '1804', 'nombre': '1804' },
            { 'id': '1805', 'nombre': '1805' },
            { 'id': '1806', 'nombre': '1806' },
            { 'id': '1807', 'nombre': '1807' },
            { 'id': '1808', 'nombre': '1808' },
            { 'id': '1809', 'nombre': '1809' },
            { 'id': '1810', 'nombre': '1810' },
            { 'id': '1811', 'nombre': '1811' },
            { 'id': '1812', 'nombre': '1812' },
            { 'id': '1813', 'nombre': '1813' },
            { 'id': '1814', 'nombre': '1814' },
            { 'id': '1815', 'nombre': '1815' },
            { 'id': '1816', 'nombre': '1816' },
            { 'id': '1817', 'nombre': '1817' },
            { 'id': '1818', 'nombre': '1818' },
            { 'id': '1819', 'nombre': '1819' },
            { 'id': '1820', 'nombre': '1820' },
            { 'id': '1821', 'nombre': '1821' },
            { 'id': '1822', 'nombre': '1822' },
            { 'id': '1823', 'nombre': '1823' },
            { 'id': '1824', 'nombre': '1824' },
            { 'id': '1825', 'nombre': '1825' },
            { 'id': '1826', 'nombre': '1826' },
            { 'id': '1827', 'nombre': '1827' },
            { 'id': '1828', 'nombre': '1828' },
            { 'id': '1829', 'nombre': '1829' },
            { 'id': '1830', 'nombre': '1830' },
            { 'id': '1831', 'nombre': '1831' },
            { 'id': '1834', 'nombre': '1834' },
            { 'id': '1835', 'nombre': '1835' },
            { 'id': '1836', 'nombre': '1836' },
            { 'id': '1837', 'nombre': '1837' },
            { 'id': '1838', 'nombre': '1838' },
            { 'id': '1839', 'nombre': '1839' },
            { 'id': '1845', 'nombre': '1845' },
            { 'id': '1848', 'nombre': '1848' },
            { 'id': '1856', 'nombre': '1856' },
            { 'id': '1884', 'nombre': '1884' },
            { 'id': '1886', 'nombre': '1886' },
            { 'id': '1890', 'nombre': '1890' },
            { 'id': '1893', 'nombre': '1893' },
            { 'id': '1894', 'nombre': '1894' },
            { 'id': '1895', 'nombre': '1895' },
            { 'id': '1897', 'nombre': '1897' },
            { 'id': '1901', 'nombre': '1901' },
            { 'id': '1906', 'nombre': '1906' },
            { 'id': '1907', 'nombre': '1907' },
            { 'id': '1913', 'nombre': '1913' },
            { 'id': '1914', 'nombre': '1914' },
            { 'id': '1915', 'nombre': '1915' },
            { 'id': '1925', 'nombre': '1925' },
            { 'id': '1931', 'nombre': '1931' },
            { 'id': '1932', 'nombre': '1932' },
            { 'id': '1933', 'nombre': '1933' },
            { 'id': '1934', 'nombre': '1934' },
            { 'id': '1935', 'nombre': '1935' },
            { 'id': '1936', 'nombre': '1936' },
            { 'id': '1937', 'nombre': '1937' },
            { 'id': '1938', 'nombre': '1938' },
            { 'id': '1939', 'nombre': '1939' },
            { 'id': '1940', 'nombre': '1940' },
            { 'id': '1941', 'nombre': '1941' },
            { 'id': '1942', 'nombre': '1942' },
            { 'id': '1943', 'nombre': '1943' },
            { 'id': '1944', 'nombre': '1944' },
            { 'id': '1945', 'nombre': '1945' },
            { 'id': '1946', 'nombre': '1946' },
            { 'id': '1947', 'nombre': '1947' },
            { 'id': '1948', 'nombre': '1948' },
            { 'id': '1949', 'nombre': '1949' },
            { 'id': '1950', 'nombre': '1950' },
            { 'id': '1951', 'nombre': '1951' },
            { 'id': '1952', 'nombre': '1952' },
            { 'id': '1956', 'nombre': '1956' },
            { 'id': '1957', 'nombre': '1957' },
            { 'id': '1958', 'nombre': '1958' },
            { 'id': '1959', 'nombre': '1959' },
            { 'id': '1960', 'nombre': '1960' },
            { 'id': '2539', 'nombre': '2539' },
            { 'id': '2541', 'nombre': '2541' },
            { 'id': '2542', 'nombre': '2542' },
            { 'id': '2587', 'nombre': '2587' },
            { 'id': '2777', 'nombre': '2777' },
            { 'id': '-', 'nombre': '-' },
            { 'id': '10', 'nombre': '10' },
            { 'id': '102', 'nombre': '102' },
            { 'id': '103', 'nombre': '103' },
            { 'id': '104', 'nombre': '104' },
            { 'id': '106', 'nombre': '106' },
            { 'id': '108', 'nombre': '108' },
            { 'id': '109', 'nombre': '109' },
            { 'id': '110', 'nombre': '110' },
            { 'id': '111', 'nombre': '111' },
            { 'id': '112', 'nombre': '112' },
            { 'id': '113', 'nombre': '113' },
            { 'id': '114', 'nombre': '114' },
            { 'id': '117', 'nombre': '117' },
            { 'id': '118', 'nombre': '118' },
            { 'id': '119', 'nombre': '119' },
            { 'id': '12', 'nombre': '12' },
            { 'id': '124', 'nombre': '124' },
            { 'id': '126', 'nombre': '126' },
            { 'id': '128', 'nombre': '128' },
            { 'id': '13', 'nombre': '13' },
            { 'id': '131', 'nombre': '131' },
            { 'id': '132', 'nombre': '132' },
            { 'id': '134', 'nombre': '134' },
            { 'id': '138', 'nombre': '138' },
            { 'id': '14', 'nombre': '14' },
            { 'id': '144', 'nombre': '144' },
            { 'id': '15', 'nombre': '15' },
            { 'id': '150', 'nombre': '150' },
            { 'id': '151', 'nombre': '151' },
            { 'id': '152', 'nombre': '152' },
            { 'id': '154', 'nombre': '154' },
            { 'id': '16', 'nombre': '16' },
            { 'id': '17', 'nombre': '17' },
            { 'id': '170', 'nombre': '170' },
            { 'id': '171', 'nombre': '171' },
            { 'id': '172', 'nombre': '172' },
            { 'id': '173', 'nombre': '173' },
            { 'id': '175', 'nombre': '175' },
            { 'id': '177', 'nombre': '177' },
            { 'id': '180', 'nombre': '180' },
            { 'id': '181', 'nombre': '181' },
            { 'id': '182', 'nombre': '182' },
            { 'id': '183', 'nombre': '183' },
            { 'id': '184', 'nombre': '184' },
            { 'id': '185', 'nombre': '185' },
            { 'id': '186', 'nombre': '186' },
            { 'id': '187', 'nombre': '187' },
            { 'id': '188', 'nombre': '188' },
            { 'id': '190/780', 'nombre': '190/780' },
            { 'id': '191/781', 'nombre': '191/781' },
            { 'id': '192/782', 'nombre': '192/782' },
            { 'id': '193/783', 'nombre': '193/783' },
            { 'id': '194/784', 'nombre': '194/784' },
            { 'id': '195/786', 'nombre': '195/786' },
            { 'id': '196/787', 'nombre': '196/787' },
            { 'id': '197/788', 'nombre': '197/788' },
            { 'id': '198/789', 'nombre': '198/789' },
            { 'id': '199/790', 'nombre': '199/790' },
            { 'id': '2', 'nombre': '2' },
            { 'id': '20', 'nombre': '20' },
            { 'id': '202', 'nombre': '202' },
            { 'id': '203', 'nombre': '203' },
            { 'id': '206', 'nombre': '206' },
            { 'id': '21', 'nombre': '21' },
            { 'id': '210', 'nombre': '210' },
            { 'id': '212', 'nombre': '212' },
            { 'id': '213', 'nombre': '213' },
            { 'id': '218', 'nombre': '218' },
            { 'id': '22', 'nombre': '22' },
            { 'id': '220', 'nombre': '220' },
            { 'id': '23', 'nombre': '23' },
            { 'id': '24', 'nombre': '24' },
            { 'id': '27', 'nombre': '27' },
            { 'id': '3', 'nombre': '3' },
            { 'id': '30', 'nombre': '30' },
            { 'id': '302', 'nombre': '302' },
            { 'id': '303', 'nombre': '303' },
            { 'id': '304', 'nombre': '304' },
            { 'id': '312', 'nombre': '312' },
            { 'id': '314', 'nombre': '314' },
            { 'id': '316', 'nombre': '316' },
            { 'id': '318', 'nombre': '318' },
            { 'id': '319', 'nombre': '319' },
            { 'id': '32', 'nombre': '32' },
            { 'id': '320', 'nombre': '320' },
            { 'id': '33', 'nombre': '33' },
            { 'id': '38', 'nombre': '38' },
            { 'id': '4', 'nombre': '4' },
            { 'id': '402', 'nombre': '402' },
            { 'id': '404', 'nombre': '404' },
            { 'id': '406', 'nombre': '406' },
            { 'id': '408', 'nombre': '408' },
            { 'id': '410', 'nombre': '410' },
            { 'id': '412', 'nombre': '412' },
            { 'id': '416', 'nombre': '416' },
            { 'id': '419', 'nombre': '419' },
            { 'id': '420', 'nombre': '420' },
            { 'id': '5', 'nombre': '5' },
            { 'id': '501', 'nombre': '501' },
            { 'id': '502', 'nombre': '502' },
            { 'id': '503', 'nombre': '503' },
            { 'id': '504', 'nombre': '504' },
            { 'id': '506', 'nombre': '506' },
            { 'id': '508', 'nombre': '508' },
            { 'id': '510', 'nombre': '510' },
            { 'id': '511', 'nombre': '511' },
            { 'id': '512', 'nombre': '512' },
            { 'id': '516', 'nombre': '516' },
            { 'id': '518', 'nombre': '518' },
            { 'id': '540', 'nombre': '540' },
            { 'id': '542', 'nombre': '542' },
            { 'id': '544', 'nombre': '544' },
            { 'id': '546', 'nombre': '546' },
            { 'id': '547', 'nombre': '547' },
            { 'id': '548', 'nombre': '548' },
            { 'id': '550', 'nombre': '550' },
            { 'id': '551', 'nombre': '551' },
            { 'id': '553', 'nombre': '553' },
            { 'id': '570', 'nombre': '570' },
            { 'id': '571', 'nombre': '571' },
            { 'id': '572', 'nombre': '572' },
            { 'id': '574', 'nombre': '574' },
            { 'id': '575', 'nombre': '575' },
            { 'id': '577', 'nombre': '577' },
            { 'id': '6', 'nombre': '6' },
            { 'id': '602', 'nombre': '602' },
            { 'id': '604', 'nombre': '604' },
            { 'id': '610', 'nombre': '610' },
            { 'id': '7', 'nombre': '7' },
            { 'id': '702', 'nombre': '702' },
            { 'id': '703', 'nombre': '703' },
            { 'id': '704', 'nombre': '704' },
            { 'id': '705', 'nombre': '705' },
            { 'id': '706', 'nombre': '706' },
            { 'id': '707', 'nombre': '707' },
            { 'id': '708', 'nombre': '708' },
            { 'id': '709', 'nombre': '709' },
            { 'id': '710', 'nombre': '710' },
            { 'id': '712', 'nombre': '712' },
            { 'id': '713', 'nombre': '713' },
            { 'id': '714', 'nombre': '714' },
            { 'id': '715', 'nombre': '715' },
            { 'id': '716', 'nombre': '716' },
            { 'id': '717', 'nombre': '717' },
            { 'id': '720', 'nombre': '720' },
            { 'id': '721', 'nombre': '721' },
            { 'id': '722', 'nombre': '722' },
            { 'id': '723', 'nombre': '723' },
            { 'id': '724', 'nombre': '724' },
            { 'id': '725', 'nombre': '725' },
            { 'id': '726', 'nombre': '726' },
            { 'id': '727', 'nombre': '727' },
            { 'id': '728', 'nombre': '728' },
            { 'id': '729', 'nombre': '729' },
            { 'id': '730', 'nombre': '730' },
            { 'id': '731', 'nombre': '731' },
            { 'id': '732', 'nombre': '732' },
            { 'id': '733', 'nombre': '733' },
            { 'id': '735', 'nombre': '735' },
            { 'id': '736', 'nombre': '736' },
            { 'id': '737', 'nombre': '737' },
            { 'id': '738', 'nombre': '738' },
            { 'id': '740', 'nombre': '740' },
            { 'id': '741', 'nombre': '741' },
            { 'id': '742', 'nombre': '742' },
            { 'id': '743', 'nombre': '743' },
            { 'id': '744', 'nombre': '744' },
            { 'id': '745', 'nombre': '745' },
            { 'id': '746', 'nombre': '746' },
            { 'id': '747', 'nombre': '747' },
            { 'id': '748', 'nombre': '748' },
            { 'id': '749', 'nombre': '749' },
            { 'id': '750', 'nombre': '750' },
            { 'id': '751', 'nombre': '751' },
            { 'id': '752', 'nombre': '752' },
            { 'id': '753', 'nombre': '753' },
            { 'id': '754', 'nombre': '754' },
            { 'id': '755', 'nombre': '755' },
            { 'id': '756', 'nombre': '756' },
            { 'id': '757', 'nombre': '757' },
            { 'id': '758', 'nombre': '758' },
            { 'id': '759', 'nombre': '759' },
            { 'id': '760', 'nombre': '760' },
            { 'id': '761', 'nombre': '761' },
            { 'id': '762', 'nombre': '762' },
            { 'id': '763', 'nombre': '763' },
            { 'id': '764', 'nombre': '764' },
            { 'id': '765', 'nombre': '765' },
            { 'id': '766', 'nombre': '766' },
            { 'id': '767', 'nombre': '767' },
            { 'id': '768', 'nombre': '768' },
            { 'id': '769', 'nombre': '769' },
            { 'id': '771', 'nombre': '771' },
            { 'id': '772', 'nombre': '772' },
            { 'id': '776', 'nombre': '776' },
            { 'id': '778', 'nombre': '778' },
            { 'id': '779', 'nombre': '779' },
            { 'id': '785', 'nombre': '785' },
            { 'id': '791', 'nombre': '791' },
            { 'id': '792', 'nombre': '792' },
            { 'id': '8', 'nombre': '8' },
            { 'id': '804', 'nombre': '804' },
            { 'id': '806', 'nombre': '806' },
            { 'id': '808', 'nombre': '808' },
            { 'id': '810', 'nombre': '810' },
            { 'id': '814', 'nombre': '814' },
            { 'id': '815', 'nombre': '815' },
            { 'id': '816', 'nombre': '816' },
            { 'id': '818', 'nombre': '818' },
            { 'id': '820', 'nombre': '820' },
            { 'id': '826', 'nombre': '826' },
            { 'id': '828', 'nombre': '828' },
            { 'id': '830', 'nombre': '830' },
            { 'id': '832', 'nombre': '832' },
            { 'id': '834', 'nombre': '834' },
            { 'id': '838', 'nombre': '838' },
            { 'id': '851', 'nombre': '851' },
            { 'id': '852', 'nombre': '852' },
            { 'id': '853', 'nombre': '853' },
            { 'id': '854', 'nombre': '854' },
            { 'id': '9', 'nombre': '9' },
            { 'id': '902', 'nombre': '902' },
            { 'id': '903', 'nombre': '903' },
            { 'id': '905', 'nombre': '905' },
            { 'id': '906', 'nombre': '906' },
            { 'id': '907', 'nombre': '907' },
            { 'id': '908', 'nombre': '908' },
            { 'id': '909', 'nombre': '909' },
            { 'id': '914', 'nombre': '914' },
            { 'id': '915', 'nombre': '915' },
            { 'id': '918', 'nombre': '918' },
            { 'id': '921', 'nombre': '921' },
            { 'id': '924', 'nombre': '924' },
            { 'id': '925', 'nombre': '925' },
            { 'id': '927', 'nombre': '927' },
            { 'id': '928', 'nombre': '928' },
            { 'id': '931', 'nombre': '931' },
            { 'id': '933', 'nombre': '933' },
            { 'id': '935', 'nombre': '935' },
            { 'id': '936', 'nombre': '936' },
            { 'id': '938', 'nombre': '938' },
            { 'id': '940', 'nombre': '940' },
            { 'id': '941', 'nombre': '941' },
            { 'id': '942', 'nombre': '942' },
            { 'id': '943', 'nombre': '943' },
            { 'id': '944', 'nombre': '944' },
            { 'id': '945', 'nombre': '945' },
            { 'id': '947', 'nombre': '947' },
            { 'id': '948', 'nombre': '948' },
            { 'id': '950', 'nombre': '950' },
            { 'id': '951', 'nombre': '951' },

        ]
    },
    getTipoSolicitud() {
        return [
            { "id": 1, "codigo": '001', "nombre": "Comercial" },
            { "id": 2, "codigo": '002', "nombre": "Técnico" },
        ]
    },
    getEtapa() {
        return [
            { "id": 1, "codigo": '001', "nombre": "CAS" },
            { "id": 2, "codigo": '001', "nombre": "CLIMATIZACIÓN" },
            { "id": 3, "codigo": '001', "nombre": "COMPRESIÓN" },
            { "id": 4, "codigo": '001', "nombre": "CONTRIBUCIÓN" },
            { "id": 5, "codigo": '001', "nombre": "DECODIFICACION" },
            { "id": 6, "codigo": '001', "nombre": "DISTRIBUCIÓN" },
            { "id": 7, "codigo": '001', "nombre": "ENERGIA" },
            { "id": 8, "codigo": '001', "nombre": "GENERACION DE STREAMS OTT" },
            { "id": 9, "codigo": '001', "nombre": "INSERCIÓN DE COMERCIALES" },
            { "id": 10, "codigo": '001', "nombre": "INTRAWAY" },
            { "id": 11, "codigo": '001', "nombre": "MODULACION" },
            { "id": 12, "codigo": '001', "nombre": "MONITOREO" },
            { "id": 13, "codigo": '001', "nombre": "MULTIPLEXACIÓN" },
            { "id": 14, "codigo": '001', "nombre": "PUBLICACIÓN" },
            { "id": 15, "codigo": '001', "nombre": "RECEPCIÓN" },
            { "id": 16, "codigo": '001', "nombre": "SITE REMOTO" },
            { "id": 17, "codigo": '001', "nombre": "SUBTÍTULOS" },
            { "id": 18, "codigo": '001', "nombre": "SW STB" },
            { "id": 19, "codigo": '001', "nombre": "TI" },
            { "id": 20, "codigo": '001', "nombre": "UPLINK" },
        ]
    },
    getTipoOrden() {
        return [
            { "id": 1, "codigo": 'WO', "nombre": "WO" },
            { "id": 2, "codigo": 'WO TASK', "nombre": "WO TASK" },
        ]
    },
    getSeveridad() {
        return [
            { "id": 1, "codigo": '001', "nombre": "Menor" },
            { "id": 2, "codigo": '002', "nombre": "Mayor" },
            { "id": 3, "codigo": '003', "nombre": "Crítica" },
        ]
    },
    getImpacto() {
        return [
            { "id": 1, "codigo": '001', "nombre": "Si" },
            { "id": 2, "codigo": '002', "nombre": "No / Alto" },
            { "id": 3, "codigo": '003', "nombre": "No / Medio" },
            { "id": 4, "codigo": '004', "nombre": "No / Bajo" },
        ]
    },
    getTaskWo() {
        return [
            { "id": 1, "codigo": '001', "nombre": "Tarea" },
            { "id": 2, "codigo": '002', "nombre": "Orden de Trabajo" },
        ]
    },
    getTipoTrabajo() {
        return [
            { "id": 1, "codigo": '001', "nombre": "Comercial" },
            { "id": 2, "codigo": '001', "nombre": "Correctivo" },
            { "id": 3, "codigo": '001', "nombre": "Dispositivos" },
            { "id": 4, "codigo": '001', "nombre": "Herramientas" },
            { "id": 5, "codigo": '001', "nombre": "Hosting" },
            { "id": 6, "codigo": '001', "nombre": "Infraestructura TI" },
            { "id": 7, "codigo": '001', "nombre": "Nuevos despliegues HW" },
            { "id": 8, "codigo": '001', "nombre": "Preventivo" },
            { "id": 9, "codigo": '001', "nombre": "Programador" },
            { "id": 10, "codigo": '001', "nombre": "Provisión" },
            { "id": 11, "codigo": '001', "nombre": "Release SW" },
            { "id": 12, "codigo": '001', "nombre": "Seguridad" },
        ]
    },
    getTipoValidacion() {
        return [
            { "id": 1, "codigo": '001', "nombre": "Validación tipo 01", 'class': 'success' },
            { "id": 2, "codigo": '002', "nombre": "Validación tipo 02", 'class': 'info' },
            { "id": 3, "codigo": '003', "nombre": "Validación tipo 03", 'class': 'secondary' },
            { "id": 4, "codigo": '003', "nombre": "Otra", 'class': 'warning' },
        ]
    },
    getRegistro() {
        return [
            { "id": 1, "grupo_act_id": '1', "nombre": "CAS - Información de servidores" },
            { "id": 2, "grupo_act_id": '3', "nombre": "Proc - CAS Ateme IP Plan - NC" },
            { "id": 3, "grupo_act_id": '3', "nombre": "Proc - Disponibilidad de plataforma DTH / CATV - NC" },
            { "id": 4, "grupo_act_id": '3', "nombre": "Proc - Generadores declarados en las plataformas - NC" },
            { "id": 5, "grupo_act_id": '3', "nombre": "Proc - Plan service OTT - C" },
            { "id": 6, "grupo_act_id": '4', "nombre": "Rf - Distribuidores de video - C" },
            { "id": 7, "grupo_act_id": '4', "nombre": "Rf - Saf Info - C" },
            { "id": 8, "grupo_act_id": '5', "nombre": "SM - Archivo de TPs Comerciales" },
            { "id": 9, "grupo_act_id": '7', "nombre": "TI - Inventario TI - NC" },
            { "id": 10, "grupo_act_id": '2', "nombre": "Infra & Energ. - Diagrama Unifamiliar - C" },
            { "id": 11, "grupo_act_id": '3', "nombre": "Proc - CAS Harmonic IP Plan - NC" },
            { "id": 12, "grupo_act_id": '3', "nombre": "Proc - Eatdo de Plataforma Sofni  - C" },
            { "id": 13, "grupo_act_id": '3', "nombre": "Proc - Plan Service DTH / CATV - C" },
            { "id": 14, "grupo_act_id": '4', "nombre": "Rf - Consolidado de señales CATV - C" },
            { "id": 15, "grupo_act_id": '4', "nombre": "Rf - Plantilla Uplink - C" },
            { "id": 16, "grupo_act_id": '5', "nombre": "SM - Archivo de señales DTH / CATV - NC" },
            { "id": 17, "grupo_act_id": '7', "nombre": "TI - Información de direccionamiento IP de los entornos productivos - NC" },
            { "id": 18, "grupo_act_id": '7', "nombre": "TI - Low Level Design NC" },

        ]
    },
    getGrupoActualizador() {
        return [
            { "id": 1, "codigo": '001', "nombre": "CAS" },
            { "id": 2, "codigo": '001', "nombre": "Infra & Energía" },
            { "id": 3, "codigo": '001', "nombre": "Procesamiento" },
            { "id": 4, "codigo": '001', "nombre": "RadioFrecuencia" },
            { "id": 5, "codigo": '001', "nombre": "Service Manager" },
            { "id": 6, "codigo": '001', "nombre": "Tools" },
            { "id": 7, "codigo": '001', "nombre": "TI" },
        ]
    },

    getTipoVinculacion() {
        return [
            { "id": 1, "nombre": "Comercial", 'class': 'success' },
            { "id": 2, "nombre": "Correctivo", 'class': 'info' },
            { "id": 3, "nombre": "WO relacionado", 'class': 'dark' },
        ]
    },


    //Fin llenar combos
    //SERVICIOS 

    async registrarOrdenUDO(orden) {
        let result = { 'success': false, message: 'Error genérico' };

        result = await axios.put("api/v1/registrar_udo/" + orden)
            .then((response) => {
                return { 'success': true, 'message': response.data.message };
            })
            .catch((error) => {
                console.log(error);
                return { 'success': false, 'message': error.response.data.message };
            });
        return result;
    },
    registrarAprobadoresUDO(orden, descripcion) {
        axios.put("api/v1/registrar_aprobadores_udo/" + orden, {})
            .then((response) => {
                this.cambiarEstadoUDO(orden, 'Pending_tech_approval', descripcion, false);
            })
            .catch((error) => {
                this.cambiarEstadoUDO(orden, 'Pending_tech_approval', descripcion, true);
            });
    },
    cambiarEstadoUDO(orden, estado, descripcion, forzar) { //Active
        axios.put("api/v1/actualizar_estado_udo/" + orden, {
                estado: estado,
                descripcion: descripcion,
                forzar: forzar
            })
            .then((response) => {
            })
            .catch((error) => {
            });
    },
    registrarNotaUDO(orden, codigo, descripcion) {
        axios.put("api/v1/registrar_nota_udo/" + orden, {
                codigo: codigo,
                descripcion: descripcion,
            })
            .then((response) => {
                console.log('se registró correctamente la nota');
            })
            .catch((error) => {
                console.log('Hubo un error al registrar la nota. ' + descripcion);
            });
    },
    async actualizarOrdenCampos(orden, json) {
        let result = { 'success': false, message: 'Error genérico' };
        result = await axios.put(
                "api/orden_trabajo/modificar/" + orden, json)
            .then((response) => {
                return { 'success': true, 'message': response.data.message };
            })
            .catch((error) => {
                console.log(error);
                return { 'success': false, 'message': error.response.data.message };
            });
        return result;
    },

    //SERVICIOS fin


    //Inicio return htmls
    getValorClaveLista(lista, valor, clave = 'id', descripcion = 'nombre') {
        let elemento = lista.find(elem => elem[clave] == valor);
        return elemento[descripcion];
    },
    getEtiquetaLista(lista, valor) {
        const estado = lista.find(elem => elem.id == valor);
        if (estado)
        //return '<span class="badge badge-' + estado.class + '">' + estado.nombre + '</span>';
            return '<span class="' + (estado.class ? ('badge badge-' + estado.class) : '') + '">' + estado.nombre + '</span>';
        else
            return '<span class="">No encontrado</span>'
    },
    getColorEstado(lista, valor, feriados) {
        var fechact = new Date().getTime();
        var FechaFin = new Date(valor);
        for (let i in feriados) {
            var ini = feriados[i].fecha_desde;
            var fin = feriados[i].fecha_hasta;
            var parts = ini.split('-');
            var fecini = new Date(parts[0], parts[1] - 1, parts[2]);
            parts = fin.split('-');
            var fecfin = new Date(parts[0], parts[1] - 1, parts[2]);
            var diff = fecfin - fecini;
            var diff = (diff / (1000 * 60 * 60 * 24));
            for (let j = 0; j <= diff; j++) {
                FechaFin.setDate(FechaFin.getDate() + 1);
            }
            var numeroDia = new Date(FechaFin).getDay();
            if (numeroDia == 6) {
                FechaFin.setDate(FechaFin.getDate() + 1);
            }
            FechaFin.setDate(FechaFin.getDate() + 2);
        }
        var diff = FechaFin - fechact;
        diff = parseInt(diff / (1000 * 60 * 60 * 24));
        console.log(diff + "    " + FechaFin);
        var color = "";
        if (diff < 2 && diff >= 0) {
            //amarillo
            color = "bg-warning";
        } else if (diff >= 2) {
            //verde
            color = "bg-success";
        } else if (diff < 0) {
            //ROJO
            color = "bg-danger";
        }
        return '<div class="' + color + '" style="width:50px; border-radius:5px;"><span>&nbsp;</span></div>';
    },
    getEstadoOrdenTrabajoEtiqueta(valor) {
        let estados = this.getEstadoOrdenTrabajo();
        const estado = estados.find(elem => elem.id == valor);
        if (estado)
            return '<span class="badge badge-' + estado.class + '">' + estado.nombre + '</span>';
        else
            return '<span class="badge">No encontrado</span>'
    },
    getTipoTrabajoEtiqueta(valor) {
        if (valor == 1)
            return '<span class="badge badge-success">Comercial</span>'
        if (valor == 2)
            return '<span class="badge badge-info">Correctivo</span>'

        else
            return '<span class="">No encontrado</span>'
    },
    getTipoAreaEtiqueta(valor) {
        if (valor == 1)
            return '<span class="badge badge-success">PAT</span>'
        if (valor == 2)
            return '<span class="badge badge-info">Ejecutor</span>'

        else
            return '<span class="">No encontrado</span>'
    },
    //Fin return htmls

    //Roles y permisos
    esSolicitante(rol) {
        if (rol == 2) //2
            return true;
        return false;
    },
    getMonthInt(valor, opcion = 'letra') {
        let arrayMonth = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octumbre', 'Noviembre', 'Diciembre'];
        let arrayMonthDigit = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
        return opcion == 'letra' ? arrayMonth[valor] : arrayMonthDigit[valor];
    },
    getFechaHoraActual() {
        return moment(new Date()).format('YYYY-MM-DD hh:mm:ss');
    },
    formatearFecha(fecha) {
        if (fecha) {
            return moment(String(fecha)).format('YYYY-MM-DDTHH:mm')
        }
    },
    formatearFechaZH(fecha) {
        if (fecha) {
            //falta
            return fecha.replace(' ', 'T');
            console.log(fecha);
            return moment(String(fecha)).format('yyyy-MM-ddThh:mm')
        }
    },
    formatearFechaNoHora(fecha) {
        if (fecha) {
            let split = fecha.split('T');
            return split[0];
        }
        return '';
    },
    formatearHoraHM(hora) {
        if (hora) {
            return hora.substring(5, 0)
        }
    },
    getFechaArray(array) { //ejm. [2021, 4, 26, 7, 0, 0, 0]
        return array[0] + '-' + this.getMonthInt(array[1], 'num') + '-' + array[2] + 'T' + array[3].toString().padStart(2, 0) + ':' + array[4].toString().padStart(2, 0) + ':' + array[5].toString().padStart(2, 0)
    },
  
    sumarHoraMinutos(tiempo, duracion, es_resta = false) {
        let splitHora = tiempo.split(':');
        let horaSegundos = splitHora[0] * 3600;
        let minutosSegundos = splitHora[1] * 60;
        let duracionSegundos = Number(duracion) * 60;
        let tiempoSegundos = 0;
        if (es_resta)
            tiempoSegundos = horaSegundos + minutosSegundos - duracionSegundos;
        else
            tiempoSegundos = horaSegundos + minutosSegundos + duracionSegundos;

        let hora = parseInt(tiempoSegundos / 3600) % 24;
        let minutos = parseInt(tiempoSegundos / 60) % 60;
        let segundos = tiempoSegundos % 60;

        //let resultado = (hora < 10 ? "0" + hora : hora) + ":" + (minutos < 10 ? "0" + minutos : minutos) + ":" + (segundos  < 10 ? "0" + segundos : segundos);
        //estrae solo hora y minutos
        let resultado = (hora < 10 ? "0" + hora : hora) + ":" + (minutos < 10 ? "0" + minutos : minutos);

        return resultado;

    },
    sumarMinutosFecha(fecha, minutos) {
        if (!fecha)
            return null;
        let fec = new Date(fecha);
        fec.setMinutes(fec.getMinutes() + minutos);
        return this.formatearFecha(fec);
    },
    getFilterURL(data) {
        let url = '';
        $.each(data, function(key, value) {
            url += (value) ? '&' + key + '=' + encodeURI(value) : '';
        });
        return url;
    },
    deshabilitarBoton(_this) {
        _this.deshabilitado = true;
    },
    habilitarBoton(_this, segundos = 1) {
        setTimeout(function() { _this.deshabilitado = false; }, (segundos * 1000));
    },
    esFechaMenor(ini, fin) {
        if (Date.parse(ini) <= Date.parse(fin))
            return true;
        return false;
    },
    esHoraMenor(ini, fin) {
        let splitIni = ini.split(':');
        let horaSegundosIni = splitIni[0] * 3600;
        let minutosSegundosIni = splitIni[1] * 60;

        let splitFin = fin.split(':');
        let horaSegundosFin = splitFin[0] * 3600;
        let minutosSegundosFin = splitFin[1] * 60;

        if ((horaSegundosIni + minutosSegundosIni) < (horaSegundosFin + minutosSegundosFin))
            return true;
        return false;
    },
    obtenerCodigo(lista, prefijo, campo, ceros) {
        if (lista.length == 0)
            return prefijo + ('1'.padStart(ceros, 0));
        let ultimoValor = Number((lista[lista.length - 1][campo]).replace(prefijo, ''))
        return prefijo + ((ultimoValor + 1).toString().padStart(ceros, 0));
    },
    random_color(format) {
        var rint = Math.floor(0x100000000 * Math.random());
        switch (format) {
            case 'hex':
                return '#' + ('00000' + rint.toString(16)).slice(-6).toUpperCase();
            case 'hexa':
                return '#' + ('0000000' + rint.toString(16)).slice(-8).toUpperCase();
            case 'rgb':
                return 'rgb(' + (rint & 255) + ',' + (rint >> 8 & 255) + ',' + (rint >> 16 & 255) + ')';
            case 'rgba':
                return 'rgba(' + (rint & 255) + ',' + (rint >> 8 & 255) + ',' + (rint >> 16 & 255) + ',' + (rint >> 24 & 255) / 255 + ')';
            default:
                return rint;
        }
    },
    validarPermisoActual(_this, valor) {
        if (_this.$store.getters.getPermisoActual == valor)
            return true;
        return false;
    },
    validarPermisos(permisos, valor) {
        let permiso = permisos.find(elem => elem.clave == valor);
        if (!permiso)
            return false;
        return permiso.valor;
    },
    validarPermisoArea(areasUsuario, area) {
        let permiso = areasUsuario.find(elem => elem.id == area);
        if (!permiso)
            return false;
        return true;
    },


    //personalizados

    quitarArrayObjeto(objeto) {
        let newObj = {};
        for (const prop in objeto) {
            if (typeof(objeto[prop]) != "object")
                newObj[prop] = objeto[prop];
        }
        return newObj;
    },
    convertirNulosBlancoObj(obj) {
        for (const prop in obj) {
            if (obj[prop] === null) {
                obj[prop] = '';
            }
        }
        return obj;
    },


    soloNumeros($event){       
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
        if ((keyCode < 48 || keyCode > 57)) { // 46 is dot
            $event.preventDefault();            
        }
    },
    soloLetrasSimples($event){       
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
        if((keyCode < 65 || keyCode >90) && (keyCode < 97 || keyCode > 122) && keyCode!=32 && keyCode!= 164 && keyCode!=165){ // 46 is dot
            $event.preventDefault();            
        }
    },

    soloFloat($event){  
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
        if($event.target.value==""){
            if (keyCode < 48 || keyCode > 57) { // 46 is dot
                $event.preventDefault();            
            }

        } 
        else{ if($event.target.value.indexOf('.')=="-1"){
                if ((keyCode < 48 || keyCode > 57) && keyCode!=46) { // 46 is dot
                    $event.preventDefault();            
                }
            }
            else{
                if ((keyCode < 48 || keyCode > 57)) { // 46 is dot
                    $event.preventDefault();            
                }
            }
           
        }    
        
        
      },
    convertirEnviar(valor,referencia,cambio){

        if(!valor)
            return 0;
        
            else{
                if(cambio){
                    return valor/referencia;
                }
                else{
                    return valor*referencia;
                }
            }
    },

    
    convertirRecibir(valor,referencia,cambio){
        if(!valor)
            return 0;
        else{
        if(cambio){
            return valor*referencia;
        }
        else{
            return valor/referencia;
        }
        
     }
    },
    
    formatDate(date){
        if(!date)
            return;
        
        return moment(date).format('YYYY-MM-DD');
    },

    limiteCaracteres($event, palabra, cantidad){
        if(palabra.length > cantidad)
            $event.preventDefault();  
    },

    actualizarTipoCambio(_this){
        //console.log('actualiza');
        axios.get('api/parametro/ListaTipoCambioActual' )
        .then(response => {   
            _this.$store.dispatch('setTipoCambio',{
                compra: response.data.Data.find(e=>e.Id=="5").TipoCambio,
                venta: response.data.Data.find(e=>e.Id=="4").TipoCambio,
            });
        }).catch(error => {
            toastr['error'](error.response.data.message);
        }); 
    },
    

}


// WEBPACK FOOTER //
// ./src/services/helpers.js